<template>
  <div :id="containerId" class="captcha-div-s"></div>
</template>

<script setup>
const props = defineProps({
  containerId: {
    type: String,
    default: "captcha-div",
  },
});

const router = useRouter();

const validate = () => {
  return new Promise((resolve, reject) => {
    const captchaConfig = {
      // 请求验证码接口
      requestCaptchaDataUrl:
        import.meta.env.VITE_APP_BASE_API + "/auth/captcha/get",
      // 验证验证码接口
      validCaptchaUrl:
        import.meta.env.VITE_APP_BASE_API + "/auth/captcha/check",
      // 绑定的div
      bindEl: `#${props.containerId}`,
      // 验证成功回调函数
      validSuccess: async (res, c, tacInstance) => {
        console.log("验证码验证成功回调...");
        tacInstance.destroyWindow();
        resolve(res);
      },
    };

    window
      .initTAC(
        (import.meta.env.DEV ? "" : router.options.history.base) +
          "/static/tac",
        captchaConfig,
      )
      .then((tac) => {
        tac.init();
      });
  });
};

defineExpose({
  validate,
});
</script>

<style lang="scss" scoped>
.captcha-div-s {
  position: absolute;
  z-index: 1001;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
